/**
 * COPYRIGHT NOTICE
 * This file is categorized as "Custom Source Code"
 * and is subject to the terms and conditions defined in the
 * "LICENSE.txt" file, which is part of this source code package.
 */
import registerComponents from '@onehat/ui/src/Functions/registerComponents.js';

import ChatMessagesCombo from '../components/Form/Field/Combo/ChatMessagesCombo.js';
import ChatMessagesComboEditor from '../components/Form/Field/Combo/ChatMessagesComboEditor.js';
import ChatMessagesTag from '../components/Form/Field/Tag/ChatMessagesTag.js';
import ChatMessagesTagEditor from '../components/Form/Field/Tag/ChatMessagesTagEditor.js';
import ChatMessagesGrid from '../components/Grid/ChatMessagesGrid.js';
import ChatMessagesGridEditor from '../components/Grid/ChatMessagesGridEditor.js';
import ChatMessagesSideGridEditor from '../components/Grid/ChatMessagesSideGridEditor.js';
import ChatMessagesInlineGridEditor from '../components/Grid/ChatMessagesInlineGridEditor.js';
import ChatMessagesFilteredGrid from '../components/Grid/ChatMessagesFilteredGrid.js';
import ChatMessagesFilteredGridEditor from '../components/Grid/ChatMessagesFilteredGridEditor.js';
import ChatMessagesFilteredSideGridEditor from '../components/Grid/ChatMessagesFilteredSideGridEditor.js';
import ChatMessagesFilteredInlineGridEditor from '../components/Grid/ChatMessagesFilteredInlineGridEditor.js';
import ChatMessagesGridPanel from '../components/Panel/Grid/ChatMessagesGrid.js';
import ChatMessagesGridEditorPanel from '../components/Panel/Grid/ChatMessagesGridEditor.js';
import ChatMessagesSideGridEditorPanel from '../components/Panel/Grid/ChatMessagesSideGridEditor.js';
import ChatMessagesInlineGridEditorPanel from '../components/Panel/Grid/ChatMessagesInlineGridEditor.js';
import ChatMessagesFilteredGridPanel from '../components/Panel/Grid/ChatMessagesFilteredGrid.js';
import ChatMessagesFilteredGridEditorPanel from '../components/Panel/Grid/ChatMessagesFilteredGridEditor.js';
import ChatMessagesFilteredSideGridEditorPanel from '../components/Panel/Grid/ChatMessagesFilteredSideGridEditor.js';
import ChatMessagesFilteredInlineGridEditorPanel from '../components/Panel/Grid/ChatMessagesFilteredInlineGridEditor.js';
import ChatMessagesEditor from '../components/Editor/ChatMessagesEditor.js';
import ChatMessagesEditorWindow from '../components/Window/ChatMessagesEditorWindow.js';
import ChatRecipientsCombo from '../components/Form/Field/Combo/ChatRecipientsCombo.js';
import ChatRecipientsComboEditor from '../components/Form/Field/Combo/ChatRecipientsComboEditor.js';
import ChatRecipientsTag from '../components/Form/Field/Tag/ChatRecipientsTag.js';
import ChatRecipientsTagEditor from '../components/Form/Field/Tag/ChatRecipientsTagEditor.js';
import ChatRecipientsGrid from '../components/Grid/ChatRecipientsGrid.js';
import ChatRecipientsGridEditor from '../components/Grid/ChatRecipientsGridEditor.js';
import ChatRecipientsSideGridEditor from '../components/Grid/ChatRecipientsSideGridEditor.js';
import ChatRecipientsInlineGridEditor from '../components/Grid/ChatRecipientsInlineGridEditor.js';
import ChatRecipientsFilteredGrid from '../components/Grid/ChatRecipientsFilteredGrid.js';
import ChatRecipientsFilteredGridEditor from '../components/Grid/ChatRecipientsFilteredGridEditor.js';
import ChatRecipientsFilteredSideGridEditor from '../components/Grid/ChatRecipientsFilteredSideGridEditor.js';
import ChatRecipientsFilteredInlineGridEditor from '../components/Grid/ChatRecipientsFilteredInlineGridEditor.js';
import ChatRecipientsGridPanel from '../components/Panel/Grid/ChatRecipientsGrid.js';
import ChatRecipientsGridEditorPanel from '../components/Panel/Grid/ChatRecipientsGridEditor.js';
import ChatRecipientsSideGridEditorPanel from '../components/Panel/Grid/ChatRecipientsSideGridEditor.js';
import ChatRecipientsInlineGridEditorPanel from '../components/Panel/Grid/ChatRecipientsInlineGridEditor.js';
import ChatRecipientsFilteredGridPanel from '../components/Panel/Grid/ChatRecipientsFilteredGrid.js';
import ChatRecipientsFilteredGridEditorPanel from '../components/Panel/Grid/ChatRecipientsFilteredGridEditor.js';
import ChatRecipientsFilteredSideGridEditorPanel from '../components/Panel/Grid/ChatRecipientsFilteredSideGridEditor.js';
import ChatRecipientsFilteredInlineGridEditorPanel from '../components/Panel/Grid/ChatRecipientsFilteredInlineGridEditor.js';
import ChatRecipientsEditor from '../components/Editor/ChatRecipientsEditor.js';
import ChatRecipientsEditorWindow from '../components/Window/ChatRecipientsEditorWindow.js';
import ChatsWithTag from '../components/Form/Field/Tag/ChatsWithTag.js';
import ChatsWithTagEditor from '../components/Form/Field/Tag/ChatsWithTagEditor.js';
import ClientsCombo from '../components/Form/Field/Combo/ClientsCombo.js';
import CoachesCombo from '../components/Form/Field/Combo/CoachesCombo.js';
import ContentTypesCombo from '../components/Form/Field/Combo/ContentTypesCombo.js';
import ContentTypesComboEditor from '../components/Form/Field/Combo/ContentTypesComboEditor.js';
import ContentTypesTag from '../components/Form/Field/Tag/ContentTypesTag.js';
import ContentTypesTagEditor from '../components/Form/Field/Tag/ContentTypesTagEditor.js';
import ContentTypesGrid from '../components/Grid/ContentTypesGrid.js';
import ContentTypesGridEditor from '../components/Grid/ContentTypesGridEditor.js';
import ContentTypesSideGridEditor from '../components/Grid/ContentTypesSideGridEditor.js';
import ContentTypesInlineGridEditor from '../components/Grid/ContentTypesInlineGridEditor.js';
import ContentTypesFilteredGrid from '../components/Grid/ContentTypesFilteredGrid.js';
import ContentTypesFilteredGridEditor from '../components/Grid/ContentTypesFilteredGridEditor.js';
import ContentTypesFilteredSideGridEditor from '../components/Grid/ContentTypesFilteredSideGridEditor.js';
import ContentTypesFilteredInlineGridEditor from '../components/Grid/ContentTypesFilteredInlineGridEditor.js';
import ContentTypesGridPanel from '../components/Panel/Grid/ContentTypesGrid.js';
import ContentTypesGridEditorPanel from '../components/Panel/Grid/ContentTypesGridEditor.js';
import ContentTypesSideGridEditorPanel from '../components/Panel/Grid/ContentTypesSideGridEditor.js';
import ContentTypesInlineGridEditorPanel from '../components/Panel/Grid/ContentTypesInlineGridEditor.js';
import ContentTypesFilteredGridPanel from '../components/Panel/Grid/ContentTypesFilteredGrid.js';
import ContentTypesFilteredGridEditorPanel from '../components/Panel/Grid/ContentTypesFilteredGridEditor.js';
import ContentTypesFilteredSideGridEditorPanel from '../components/Panel/Grid/ContentTypesFilteredSideGridEditor.js';
import ContentTypesFilteredInlineGridEditorPanel from '../components/Panel/Grid/ContentTypesFilteredInlineGridEditor.js';
import ContentTypesEditor from '../components/Editor/ContentTypesEditor.js';
import ContentTypesEditorWindow from '../components/Window/ContentTypesEditorWindow.js';
import ContentsCombo from '../components/Form/Field/Combo/ContentsCombo.js';
import ContentsComboEditor from '../components/Form/Field/Combo/ContentsComboEditor.js';
import ContentsTag from '../components/Form/Field/Tag/ContentsTag.js';
import ContentsTagEditor from '../components/Form/Field/Tag/ContentsTagEditor.js';
import ContentsGrid from '../components/Grid/ContentsGrid.js';
import ContentsGridEditor from '../components/Grid/ContentsGridEditor.js';
import ContentsSideGridEditor from '../components/Grid/ContentsSideGridEditor.js';
import ContentsInlineGridEditor from '../components/Grid/ContentsInlineGridEditor.js';
import ContentsFilteredGrid from '../components/Grid/ContentsFilteredGrid.js';
import ContentsFilteredGridEditor from '../components/Grid/ContentsFilteredGridEditor.js';
import ContentsFilteredSideGridEditor from '../components/Grid/ContentsFilteredSideGridEditor.js';
import ContentsFilteredInlineGridEditor from '../components/Grid/ContentsFilteredInlineGridEditor.js';
import ContentsGridPanel from '../components/Panel/Grid/ContentsGrid.js';
import ContentsGridEditorPanel from '../components/Panel/Grid/ContentsGridEditor.js';
import ContentsSideGridEditorPanel from '../components/Panel/Grid/ContentsSideGridEditor.js';
import ContentsInlineGridEditorPanel from '../components/Panel/Grid/ContentsInlineGridEditor.js';
import ContentsFilteredGridPanel from '../components/Panel/Grid/ContentsFilteredGrid.js';
import ContentsFilteredGridEditorPanel from '../components/Panel/Grid/ContentsFilteredGridEditor.js';
import ContentsFilteredSideGridEditorPanel from '../components/Panel/Grid/ContentsFilteredSideGridEditor.js';
import ContentsFilteredInlineGridEditorPanel from '../components/Panel/Grid/ContentsFilteredInlineGridEditor.js';
import ContentsEditor from '../components/Editor/ContentsEditor.js';
import ContentsEditorWindow from '../components/Window/ContentsEditorWindow.js';
import EngagementsCombo from '../components/Form/Field/Combo/EngagementsCombo.js';
import EngagementsComboEditor from '../components/Form/Field/Combo/EngagementsComboEditor.js';
import EngagementsTag from '../components/Form/Field/Tag/EngagementsTag.js';
import EngagementsTagEditor from '../components/Form/Field/Tag/EngagementsTagEditor.js';
import EngagementsGrid from '../components/Grid/EngagementsGrid.js';
import EngagementsGridEditor from '../components/Grid/EngagementsGridEditor.js';
import EngagementsSideGridEditor from '../components/Grid/EngagementsSideGridEditor.js';
import EngagementsInlineGridEditor from '../components/Grid/EngagementsInlineGridEditor.js';
import EngagementsFilteredGrid from '../components/Grid/EngagementsFilteredGrid.js';
import EngagementsFilteredGridEditor from '../components/Grid/EngagementsFilteredGridEditor.js';
import EngagementsFilteredSideGridEditor from '../components/Grid/EngagementsFilteredSideGridEditor.js';
import EngagementsFilteredInlineGridEditor from '../components/Grid/EngagementsFilteredInlineGridEditor.js';
import EngagementsGridPanel from '../components/Panel/Grid/EngagementsGrid.js';
import EngagementsGridEditorPanel from '../components/Panel/Grid/EngagementsGridEditor.js';
import EngagementsSideGridEditorPanel from '../components/Panel/Grid/EngagementsSideGridEditor.js';
import EngagementsInlineGridEditorPanel from '../components/Panel/Grid/EngagementsInlineGridEditor.js';
import EngagementsFilteredGridPanel from '../components/Panel/Grid/EngagementsFilteredGrid.js';
import EngagementsFilteredGridEditorPanel from '../components/Panel/Grid/EngagementsFilteredGridEditor.js';
import EngagementsFilteredSideGridEditorPanel from '../components/Panel/Grid/EngagementsFilteredSideGridEditor.js';
import EngagementsFilteredInlineGridEditorPanel from '../components/Panel/Grid/EngagementsFilteredInlineGridEditor.js';
import EngagementsEditor from '../components/Editor/EngagementsEditor.js';
import EngagementsEditorWindow from '../components/Window/EngagementsEditorWindow.js';
import GroupsCombo from '../components/Form/Field/Combo/GroupsCombo.js';
import GroupsComboEditor from '../components/Form/Field/Combo/GroupsComboEditor.js';
import GroupsTag from '../components/Form/Field/Tag/GroupsTag.js';
import GroupsTagEditor from '../components/Form/Field/Tag/GroupsTagEditor.js';
import GroupsGrid from '../components/Grid/GroupsGrid.js';
import GroupsGridEditor from '../components/Grid/GroupsGridEditor.js';
import GroupsSideGridEditor from '../components/Grid/GroupsSideGridEditor.js';
import GroupsInlineGridEditor from '../components/Grid/GroupsInlineGridEditor.js';
import GroupsFilteredGrid from '../components/Grid/GroupsFilteredGrid.js';
import GroupsFilteredGridEditor from '../components/Grid/GroupsFilteredGridEditor.js';
import GroupsFilteredSideGridEditor from '../components/Grid/GroupsFilteredSideGridEditor.js';
import GroupsFilteredInlineGridEditor from '../components/Grid/GroupsFilteredInlineGridEditor.js';
import GroupsGridPanel from '../components/Panel/Grid/GroupsGrid.js';
import GroupsGridEditorPanel from '../components/Panel/Grid/GroupsGridEditor.js';
import GroupsSideGridEditorPanel from '../components/Panel/Grid/GroupsSideGridEditor.js';
import GroupsInlineGridEditorPanel from '../components/Panel/Grid/GroupsInlineGridEditor.js';
import GroupsFilteredGridPanel from '../components/Panel/Grid/GroupsFilteredGrid.js';
import GroupsFilteredGridEditorPanel from '../components/Panel/Grid/GroupsFilteredGridEditor.js';
import GroupsFilteredSideGridEditorPanel from '../components/Panel/Grid/GroupsFilteredSideGridEditor.js';
import GroupsFilteredInlineGridEditorPanel from '../components/Panel/Grid/GroupsFilteredInlineGridEditor.js';
import GroupsEditor from '../components/Editor/GroupsEditor.js';
import GroupsEditorWindow from '../components/Window/GroupsEditorWindow.js';
import GroupsUsersCombo from '../components/Form/Field/Combo/GroupsUsersCombo.js';
import GroupsUsersComboEditor from '../components/Form/Field/Combo/GroupsUsersComboEditor.js';
import GroupsUsersTag from '../components/Form/Field/Tag/GroupsUsersTag.js';
import GroupsUsersTagEditor from '../components/Form/Field/Tag/GroupsUsersTagEditor.js';
import GroupsUsersGrid from '../components/Grid/GroupsUsersGrid.js';
import GroupsUsersGridEditor from '../components/Grid/GroupsUsersGridEditor.js';
import GroupsUsersSideGridEditor from '../components/Grid/GroupsUsersSideGridEditor.js';
import GroupsUsersInlineGridEditor from '../components/Grid/GroupsUsersInlineGridEditor.js';
import GroupsUsersFilteredGrid from '../components/Grid/GroupsUsersFilteredGrid.js';
import GroupsUsersFilteredGridEditor from '../components/Grid/GroupsUsersFilteredGridEditor.js';
import GroupsUsersFilteredSideGridEditor from '../components/Grid/GroupsUsersFilteredSideGridEditor.js';
import GroupsUsersFilteredInlineGridEditor from '../components/Grid/GroupsUsersFilteredInlineGridEditor.js';
import GroupsUsersGridPanel from '../components/Panel/Grid/GroupsUsersGrid.js';
import GroupsUsersGridEditorPanel from '../components/Panel/Grid/GroupsUsersGridEditor.js';
import GroupsUsersSideGridEditorPanel from '../components/Panel/Grid/GroupsUsersSideGridEditor.js';
import GroupsUsersInlineGridEditorPanel from '../components/Panel/Grid/GroupsUsersInlineGridEditor.js';
import GroupsUsersFilteredGridPanel from '../components/Panel/Grid/GroupsUsersFilteredGrid.js';
import GroupsUsersFilteredGridEditorPanel from '../components/Panel/Grid/GroupsUsersFilteredGridEditor.js';
import GroupsUsersFilteredSideGridEditorPanel from '../components/Panel/Grid/GroupsUsersFilteredSideGridEditor.js';
import GroupsUsersFilteredInlineGridEditorPanel from '../components/Panel/Grid/GroupsUsersFilteredInlineGridEditor.js';
import GroupsUsersEditor from '../components/Editor/GroupsUsersEditor.js';
import GroupsUsersEditorWindow from '../components/Window/GroupsUsersEditorWindow.js';
import GroupsUsersGridSideA from '../components/Grid/GroupsUsersGridSideA.js';
import GroupsUsersGridSideB from '../components/Grid/GroupsUsersGridSideB.js';
import GroupsUsersGridEditorSideA from '../components/Grid/GroupsUsersGridEditorSideA.js';
import GroupsUsersGridEditorSideB from '../components/Grid/GroupsUsersGridEditorSideB.js';
import GroupsUsersFilteredGridEditorSideA from '../components/Grid/GroupsUsersFilteredGridEditorSideA.js';
import GroupsUsersFilteredGridEditorSideB from '../components/Grid/GroupsUsersFilteredGridEditorSideB.js';
import GroupsUsersEditorWindowSideA from '../components/Window/GroupsUsersEditorWindowSideA.js';
import GroupsUsersEditorWindowSideB from '../components/Window/GroupsUsersEditorWindowSideB.js';
import GroupsUsersEditorSideA from '../components/Editor/GroupsUsersEditorSideA.js';
import GroupsUsersEditorSideB from '../components/Editor/GroupsUsersEditorSideB.js';
import PermissionsCombo from '../components/Form/Field/Combo/PermissionsCombo.js';
import PermissionsComboEditor from '../components/Form/Field/Combo/PermissionsComboEditor.js';
import PermissionsTag from '../components/Form/Field/Tag/PermissionsTag.js';
import PermissionsTagEditor from '../components/Form/Field/Tag/PermissionsTagEditor.js';
import PermissionsGrid from '../components/Grid/PermissionsGrid.js';
import PermissionsGridEditor from '../components/Grid/PermissionsGridEditor.js';
import PermissionsSideGridEditor from '../components/Grid/PermissionsSideGridEditor.js';
import PermissionsInlineGridEditor from '../components/Grid/PermissionsInlineGridEditor.js';
import PermissionsFilteredGrid from '../components/Grid/PermissionsFilteredGrid.js';
import PermissionsFilteredGridEditor from '../components/Grid/PermissionsFilteredGridEditor.js';
import PermissionsFilteredSideGridEditor from '../components/Grid/PermissionsFilteredSideGridEditor.js';
import PermissionsFilteredInlineGridEditor from '../components/Grid/PermissionsFilteredInlineGridEditor.js';
import PermissionsGridPanel from '../components/Panel/Grid/PermissionsGrid.js';
import PermissionsGridEditorPanel from '../components/Panel/Grid/PermissionsGridEditor.js';
import PermissionsSideGridEditorPanel from '../components/Panel/Grid/PermissionsSideGridEditor.js';
import PermissionsInlineGridEditorPanel from '../components/Panel/Grid/PermissionsInlineGridEditor.js';
import PermissionsFilteredGridPanel from '../components/Panel/Grid/PermissionsFilteredGrid.js';
import PermissionsFilteredGridEditorPanel from '../components/Panel/Grid/PermissionsFilteredGridEditor.js';
import PermissionsFilteredSideGridEditorPanel from '../components/Panel/Grid/PermissionsFilteredSideGridEditor.js';
import PermissionsFilteredInlineGridEditorPanel from '../components/Panel/Grid/PermissionsFilteredInlineGridEditor.js';
import PermissionsEditor from '../components/Editor/PermissionsEditor.js';
import PermissionsEditorWindow from '../components/Window/PermissionsEditorWindow.js';
import RatingsCombo from '../components/Form/Field/Combo/RatingsCombo.js';
import RatingsComboEditor from '../components/Form/Field/Combo/RatingsComboEditor.js';
import RatingsTag from '../components/Form/Field/Tag/RatingsTag.js';
import RatingsTagEditor from '../components/Form/Field/Tag/RatingsTagEditor.js';
import RatingsGrid from '../components/Grid/RatingsGrid.js';
import RatingsGridEditor from '../components/Grid/RatingsGridEditor.js';
import RatingsSideGridEditor from '../components/Grid/RatingsSideGridEditor.js';
import RatingsInlineGridEditor from '../components/Grid/RatingsInlineGridEditor.js';
import RatingsFilteredGrid from '../components/Grid/RatingsFilteredGrid.js';
import RatingsFilteredGridEditor from '../components/Grid/RatingsFilteredGridEditor.js';
import RatingsFilteredSideGridEditor from '../components/Grid/RatingsFilteredSideGridEditor.js';
import RatingsFilteredInlineGridEditor from '../components/Grid/RatingsFilteredInlineGridEditor.js';
import RatingsGridPanel from '../components/Panel/Grid/RatingsGrid.js';
import RatingsGridEditorPanel from '../components/Panel/Grid/RatingsGridEditor.js';
import RatingsSideGridEditorPanel from '../components/Panel/Grid/RatingsSideGridEditor.js';
import RatingsInlineGridEditorPanel from '../components/Panel/Grid/RatingsInlineGridEditor.js';
import RatingsFilteredGridPanel from '../components/Panel/Grid/RatingsFilteredGrid.js';
import RatingsFilteredGridEditorPanel from '../components/Panel/Grid/RatingsFilteredGridEditor.js';
import RatingsFilteredSideGridEditorPanel from '../components/Panel/Grid/RatingsFilteredSideGridEditor.js';
import RatingsFilteredInlineGridEditorPanel from '../components/Panel/Grid/RatingsFilteredInlineGridEditor.js';
import RatingsEditor from '../components/Editor/RatingsEditor.js';
import RatingsEditorWindow from '../components/Window/RatingsEditorWindow.js';
import ScreenTypesCombo from '../components/Form/Field/Combo/ScreenTypesCombo.js';
import ScreenTypesComboEditor from '../components/Form/Field/Combo/ScreenTypesComboEditor.js';
import ScreenTypesTag from '../components/Form/Field/Tag/ScreenTypesTag.js';
import ScreenTypesTagEditor from '../components/Form/Field/Tag/ScreenTypesTagEditor.js';
import ScreenTypesGrid from '../components/Grid/ScreenTypesGrid.js';
import ScreenTypesGridEditor from '../components/Grid/ScreenTypesGridEditor.js';
import ScreenTypesSideGridEditor from '../components/Grid/ScreenTypesSideGridEditor.js';
import ScreenTypesInlineGridEditor from '../components/Grid/ScreenTypesInlineGridEditor.js';
import ScreenTypesFilteredGrid from '../components/Grid/ScreenTypesFilteredGrid.js';
import ScreenTypesFilteredGridEditor from '../components/Grid/ScreenTypesFilteredGridEditor.js';
import ScreenTypesFilteredSideGridEditor from '../components/Grid/ScreenTypesFilteredSideGridEditor.js';
import ScreenTypesFilteredInlineGridEditor from '../components/Grid/ScreenTypesFilteredInlineGridEditor.js';
import ScreenTypesGridPanel from '../components/Panel/Grid/ScreenTypesGrid.js';
import ScreenTypesGridEditorPanel from '../components/Panel/Grid/ScreenTypesGridEditor.js';
import ScreenTypesSideGridEditorPanel from '../components/Panel/Grid/ScreenTypesSideGridEditor.js';
import ScreenTypesInlineGridEditorPanel from '../components/Panel/Grid/ScreenTypesInlineGridEditor.js';
import ScreenTypesFilteredGridPanel from '../components/Panel/Grid/ScreenTypesFilteredGrid.js';
import ScreenTypesFilteredGridEditorPanel from '../components/Panel/Grid/ScreenTypesFilteredGridEditor.js';
import ScreenTypesFilteredSideGridEditorPanel from '../components/Panel/Grid/ScreenTypesFilteredSideGridEditor.js';
import ScreenTypesFilteredInlineGridEditorPanel from '../components/Panel/Grid/ScreenTypesFilteredInlineGridEditor.js';
import ScreenTypesEditor from '../components/Editor/ScreenTypesEditor.js';
import ScreenTypesEditorWindow from '../components/Window/ScreenTypesEditorWindow.js';
import ScreensCombo from '../components/Form/Field/Combo/ScreensCombo.js';
import ScreensComboEditor from '../components/Form/Field/Combo/ScreensComboEditor.js';
import ScreensTag from '../components/Form/Field/Tag/ScreensTag.js';
import ScreensTagEditor from '../components/Form/Field/Tag/ScreensTagEditor.js';
import ScreensGrid from '../components/Grid/ScreensGrid.js';
import ScreensGridEditor from '../components/Grid/ScreensGridEditor.js';
import ScreensSideGridEditor from '../components/Grid/ScreensSideGridEditor.js';
import ScreensInlineGridEditor from '../components/Grid/ScreensInlineGridEditor.js';
import ScreensFilteredGrid from '../components/Grid/ScreensFilteredGrid.js';
import ScreensFilteredGridEditor from '../components/Grid/ScreensFilteredGridEditor.js';
import ScreensFilteredSideGridEditor from '../components/Grid/ScreensFilteredSideGridEditor.js';
import ScreensFilteredInlineGridEditor from '../components/Grid/ScreensFilteredInlineGridEditor.js';
import ScreensGridPanel from '../components/Panel/Grid/ScreensGrid.js';
import ScreensGridEditorPanel from '../components/Panel/Grid/ScreensGridEditor.js';
import ScreensSideGridEditorPanel from '../components/Panel/Grid/ScreensSideGridEditor.js';
import ScreensInlineGridEditorPanel from '../components/Panel/Grid/ScreensInlineGridEditor.js';
import ScreensFilteredGridPanel from '../components/Panel/Grid/ScreensFilteredGrid.js';
import ScreensFilteredGridEditorPanel from '../components/Panel/Grid/ScreensFilteredGridEditor.js';
import ScreensFilteredSideGridEditorPanel from '../components/Panel/Grid/ScreensFilteredSideGridEditor.js';
import ScreensFilteredInlineGridEditorPanel from '../components/Panel/Grid/ScreensFilteredInlineGridEditor.js';
import ScreensEditor from '../components/Editor/ScreensEditor.js';
import ScreensEditorWindow from '../components/Window/ScreensEditorWindow.js';
import UsersCombo from '../components/Form/Field/Combo/UsersCombo.js';
import UsersComboEditor from '../components/Form/Field/Combo/UsersComboEditor.js';
import UsersTag from '../components/Form/Field/Tag/UsersTag.js';
import UsersTagEditor from '../components/Form/Field/Tag/UsersTagEditor.js';
import UsersGrid from '../components/Grid/UsersGrid.js';
import UsersGridEditor from '../components/Grid/UsersGridEditor.js';
import UsersSideGridEditor from '../components/Grid/UsersSideGridEditor.js';
import UsersInlineGridEditor from '../components/Grid/UsersInlineGridEditor.js';
import UsersFilteredGrid from '../components/Grid/UsersFilteredGrid.js';
import UsersFilteredGridEditor from '../components/Grid/UsersFilteredGridEditor.js';
import UsersFilteredSideGridEditor from '../components/Grid/UsersFilteredSideGridEditor.js';
import UsersFilteredInlineGridEditor from '../components/Grid/UsersFilteredInlineGridEditor.js';
import UsersGridPanel from '../components/Panel/Grid/UsersGrid.js';
import UsersGridEditorPanel from '../components/Panel/Grid/UsersGridEditor.js';
import UsersSideGridEditorPanel from '../components/Panel/Grid/UsersSideGridEditor.js';
import UsersInlineGridEditorPanel from '../components/Panel/Grid/UsersInlineGridEditor.js';
import UsersFilteredGridPanel from '../components/Panel/Grid/UsersFilteredGrid.js';
import UsersFilteredGridEditorPanel from '../components/Panel/Grid/UsersFilteredGridEditor.js';
import UsersFilteredSideGridEditorPanel from '../components/Panel/Grid/UsersFilteredSideGridEditor.js';
import UsersFilteredInlineGridEditorPanel from '../components/Panel/Grid/UsersFilteredInlineGridEditor.js';
import UsersEditor from '../components/Editor/UsersEditor.js';
import UsersEditorWindow from '../components/Window/UsersEditorWindow.js';

export default function registerComponentsFn() {

	registerComponents({
		ChatMessagesCombo,
		ChatMessagesComboEditor,
		ChatMessagesTag,
		ChatMessagesTagEditor,
		ChatMessagesGrid,
		ChatMessagesGridEditor,
		ChatMessagesSideGridEditor,
		ChatMessagesInlineGridEditor,
		ChatMessagesFilteredGrid,
		ChatMessagesFilteredGridEditor,
		ChatMessagesFilteredSideGridEditor,
		ChatMessagesFilteredInlineGridEditor,
		ChatMessagesGridPanel,
		ChatMessagesGridEditorPanel,
		ChatMessagesSideGridEditorPanel,
		ChatMessagesInlineGridEditorPanel,
		ChatMessagesFilteredGridPanel,
		ChatMessagesFilteredGridEditorPanel,
		ChatMessagesFilteredSideGridEditorPanel,
		ChatMessagesFilteredInlineGridEditorPanel,
		ChatMessagesEditor,
		ChatMessagesEditorWindow,
		ChatRecipientsCombo,
		ChatRecipientsComboEditor,
		ChatRecipientsTag,
		ChatRecipientsTagEditor,
		ChatRecipientsGrid,
		ChatRecipientsGridEditor,
		ChatRecipientsSideGridEditor,
		ChatRecipientsInlineGridEditor,
		ChatRecipientsFilteredGrid,
		ChatRecipientsFilteredGridEditor,
		ChatRecipientsFilteredSideGridEditor,
		ChatRecipientsFilteredInlineGridEditor,
		ChatRecipientsGridPanel,
		ChatRecipientsGridEditorPanel,
		ChatRecipientsSideGridEditorPanel,
		ChatRecipientsInlineGridEditorPanel,
		ChatRecipientsFilteredGridPanel,
		ChatRecipientsFilteredGridEditorPanel,
		ChatRecipientsFilteredSideGridEditorPanel,
		ChatRecipientsFilteredInlineGridEditorPanel,
		ChatRecipientsEditor,
		ChatRecipientsEditorWindow,
		ChatsWithTag,
		ChatsWithTagEditor,
		ClientsCombo,
		CoachesCombo,
		ContentTypesCombo,
		ContentTypesComboEditor,
		ContentTypesTag,
		ContentTypesTagEditor,
		ContentTypesGrid,
		ContentTypesGridEditor,
		ContentTypesSideGridEditor,
		ContentTypesInlineGridEditor,
		ContentTypesFilteredGrid,
		ContentTypesFilteredGridEditor,
		ContentTypesFilteredSideGridEditor,
		ContentTypesFilteredInlineGridEditor,
		ContentTypesGridPanel,
		ContentTypesGridEditorPanel,
		ContentTypesSideGridEditorPanel,
		ContentTypesInlineGridEditorPanel,
		ContentTypesFilteredGridPanel,
		ContentTypesFilteredGridEditorPanel,
		ContentTypesFilteredSideGridEditorPanel,
		ContentTypesFilteredInlineGridEditorPanel,
		ContentTypesEditor,
		ContentTypesEditorWindow,
		ContentsCombo,
		ContentsComboEditor,
		ContentsTag,
		ContentsTagEditor,
		ContentsGrid,
		ContentsGridEditor,
		ContentsSideGridEditor,
		ContentsInlineGridEditor,
		ContentsFilteredGrid,
		ContentsFilteredGridEditor,
		ContentsFilteredSideGridEditor,
		ContentsFilteredInlineGridEditor,
		ContentsGridPanel,
		ContentsGridEditorPanel,
		ContentsSideGridEditorPanel,
		ContentsInlineGridEditorPanel,
		ContentsFilteredGridPanel,
		ContentsFilteredGridEditorPanel,
		ContentsFilteredSideGridEditorPanel,
		ContentsFilteredInlineGridEditorPanel,
		ContentsEditor,
		ContentsEditorWindow,
		EngagementsCombo,
		EngagementsComboEditor,
		EngagementsTag,
		EngagementsTagEditor,
		EngagementsGrid,
		EngagementsGridEditor,
		EngagementsSideGridEditor,
		EngagementsInlineGridEditor,
		EngagementsFilteredGrid,
		EngagementsFilteredGridEditor,
		EngagementsFilteredSideGridEditor,
		EngagementsFilteredInlineGridEditor,
		EngagementsGridPanel,
		EngagementsGridEditorPanel,
		EngagementsSideGridEditorPanel,
		EngagementsInlineGridEditorPanel,
		EngagementsFilteredGridPanel,
		EngagementsFilteredGridEditorPanel,
		EngagementsFilteredSideGridEditorPanel,
		EngagementsFilteredInlineGridEditorPanel,
		EngagementsEditor,
		EngagementsEditorWindow,
		GroupsCombo,
		GroupsComboEditor,
		GroupsTag,
		GroupsTagEditor,
		GroupsGrid,
		GroupsGridEditor,
		GroupsSideGridEditor,
		GroupsInlineGridEditor,
		GroupsFilteredGrid,
		GroupsFilteredGridEditor,
		GroupsFilteredSideGridEditor,
		GroupsFilteredInlineGridEditor,
		GroupsGridPanel,
		GroupsGridEditorPanel,
		GroupsSideGridEditorPanel,
		GroupsInlineGridEditorPanel,
		GroupsFilteredGridPanel,
		GroupsFilteredGridEditorPanel,
		GroupsFilteredSideGridEditorPanel,
		GroupsFilteredInlineGridEditorPanel,
		GroupsEditor,
		GroupsEditorWindow,
		GroupsUsersCombo,
		GroupsUsersComboEditor,
		GroupsUsersTag,
		GroupsUsersTagEditor,
		GroupsUsersGrid,
		GroupsUsersGridEditor,
		GroupsUsersSideGridEditor,
		GroupsUsersInlineGridEditor,
		GroupsUsersFilteredGrid,
		GroupsUsersFilteredGridEditor,
		GroupsUsersFilteredSideGridEditor,
		GroupsUsersFilteredInlineGridEditor,
		GroupsUsersGridPanel,
		GroupsUsersGridEditorPanel,
		GroupsUsersSideGridEditorPanel,
		GroupsUsersInlineGridEditorPanel,
		GroupsUsersFilteredGridPanel,
		GroupsUsersFilteredGridEditorPanel,
		GroupsUsersFilteredSideGridEditorPanel,
		GroupsUsersFilteredInlineGridEditorPanel,
		GroupsUsersEditor,
		GroupsUsersEditorWindow,
		GroupsUsersGridSideA,
		GroupsUsersGridSideB,
		GroupsUsersGridEditorSideA,
		GroupsUsersGridEditorSideB,
		GroupsUsersFilteredGridEditorSideA,
		GroupsUsersFilteredGridEditorSideB,
		GroupsUsersEditorWindowSideA,
		GroupsUsersEditorWindowSideB,
		GroupsUsersEditorSideA,
		GroupsUsersEditorSideB,
		PermissionsCombo,
		PermissionsComboEditor,
		PermissionsTag,
		PermissionsTagEditor,
		PermissionsGrid,
		PermissionsGridEditor,
		PermissionsSideGridEditor,
		PermissionsInlineGridEditor,
		PermissionsFilteredGrid,
		PermissionsFilteredGridEditor,
		PermissionsFilteredSideGridEditor,
		PermissionsFilteredInlineGridEditor,
		PermissionsGridPanel,
		PermissionsGridEditorPanel,
		PermissionsSideGridEditorPanel,
		PermissionsInlineGridEditorPanel,
		PermissionsFilteredGridPanel,
		PermissionsFilteredGridEditorPanel,
		PermissionsFilteredSideGridEditorPanel,
		PermissionsFilteredInlineGridEditorPanel,
		PermissionsEditor,
		PermissionsEditorWindow,
		RatingsCombo,
		RatingsComboEditor,
		RatingsTag,
		RatingsTagEditor,
		RatingsGrid,
		RatingsGridEditor,
		RatingsSideGridEditor,
		RatingsInlineGridEditor,
		RatingsFilteredGrid,
		RatingsFilteredGridEditor,
		RatingsFilteredSideGridEditor,
		RatingsFilteredInlineGridEditor,
		RatingsGridPanel,
		RatingsGridEditorPanel,
		RatingsSideGridEditorPanel,
		RatingsInlineGridEditorPanel,
		RatingsFilteredGridPanel,
		RatingsFilteredGridEditorPanel,
		RatingsFilteredSideGridEditorPanel,
		RatingsFilteredInlineGridEditorPanel,
		RatingsEditor,
		RatingsEditorWindow,
		ScreenTypesCombo,
		ScreenTypesComboEditor,
		ScreenTypesTag,
		ScreenTypesTagEditor,
		ScreenTypesGrid,
		ScreenTypesGridEditor,
		ScreenTypesSideGridEditor,
		ScreenTypesInlineGridEditor,
		ScreenTypesFilteredGrid,
		ScreenTypesFilteredGridEditor,
		ScreenTypesFilteredSideGridEditor,
		ScreenTypesFilteredInlineGridEditor,
		ScreenTypesGridPanel,
		ScreenTypesGridEditorPanel,
		ScreenTypesSideGridEditorPanel,
		ScreenTypesInlineGridEditorPanel,
		ScreenTypesFilteredGridPanel,
		ScreenTypesFilteredGridEditorPanel,
		ScreenTypesFilteredSideGridEditorPanel,
		ScreenTypesFilteredInlineGridEditorPanel,
		ScreenTypesEditor,
		ScreenTypesEditorWindow,
		ScreensCombo,
		ScreensComboEditor,
		ScreensTag,
		ScreensTagEditor,
		ScreensGrid,
		ScreensGridEditor,
		ScreensSideGridEditor,
		ScreensInlineGridEditor,
		ScreensFilteredGrid,
		ScreensFilteredGridEditor,
		ScreensFilteredSideGridEditor,
		ScreensFilteredInlineGridEditor,
		ScreensGridPanel,
		ScreensGridEditorPanel,
		ScreensSideGridEditorPanel,
		ScreensInlineGridEditorPanel,
		ScreensFilteredGridPanel,
		ScreensFilteredGridEditorPanel,
		ScreensFilteredSideGridEditorPanel,
		ScreensFilteredInlineGridEditorPanel,
		ScreensEditor,
		ScreensEditorWindow,
		UsersCombo,
		UsersComboEditor,
		UsersTag,
		UsersTagEditor,
		UsersGrid,
		UsersGridEditor,
		UsersSideGridEditor,
		UsersInlineGridEditor,
		UsersFilteredGrid,
		UsersFilteredGridEditor,
		UsersFilteredSideGridEditor,
		UsersFilteredInlineGridEditor,
		UsersGridPanel,
		UsersGridEditorPanel,
		UsersSideGridEditorPanel,
		UsersInlineGridEditorPanel,
		UsersFilteredGridPanel,
		UsersFilteredGridEditorPanel,
		UsersFilteredSideGridEditorPanel,
		UsersFilteredInlineGridEditorPanel,
		UsersEditor,
		UsersEditorWindow
	});
	
}
